import React from 'react';

function Home() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-6 text-gray-800">Welcome to Elevate Sports Center</h1>
        <p className="text-xl text-gray-600 mb-8">Coming Soon - Your Ultimate Sports Destination</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-200">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our Facilities</h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-600">
            <li>Multiple sports courts (Padel, Tennis, Football, Squash)</li>
            <li>Modern coffee shop</li>
            <li>Sports retail shop</li>
            <li>Women's exclusive spa (coming soon)</li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-200">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our App Features</h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-600">
            <li>Easy court booking system</li>
            <li>Secure online payments</li>
            <li>Payment splitting among players</li>
            <li>Retail shop integration</li>
            <li>Membership management</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 text-center">
        <p className="text-lg text-gray-600">
          We're currently in development and will be launching soon. Stay tuned for updates!
        </p>
      </div>
    </div>
  );
}

export default Home; 